import { Camera } from "../render/Camera";
import type { Demo, Scene } from "./types";
import { makeWorld, floor, box } from "./helpers";

export const stack: Demo = {
	id: "stack",
	title: "Tall stack",
	blurb:
		"A single tall column of boxes. Without warm starting these wobble and topple; with it they stand rock-steady.",
	category: "Stacking & Stress",
	build(): Scene {
		const world = makeWorld();
		floor(world, 30);

		const size = 1;
		const gap = 0.02;
		for (let i = 0; i < 14; i++) {
			// Tiny jitter so it's a real test, not a perfectly aligned cheat.
			const jitter = (i % 2 === 0 ? 1 : -1) * 0.015;
			box(world, jitter, -size / 2 - i * (size + gap), size, size, { friction: 0.7 });
		}

		return { world, camera: new Camera(0, -4.5, 30) };
	},
};
